import { Tooltip } from "antd";
import React from "react";

const RenderTxt = (text) => {
  if (text === "" || text === null || text === undefined) {
    return "-";
  }
  return (
    <Tooltip placement="topLeft" title={text}>
      {text}
    </Tooltip>
  );
};

export default RenderTxt;
